import { Layout } from '../components';

import { EtcPanel } from '#/components/ui/tickets/components/panels/EtcPanel';
import { HighwayMaintenanceFeePanel } from '#/components/ui/tickets/components/panels/HighwayMaintenanceFeePanel';
import { CompulsoryInsurancePenaltyPanel } from '#/components/ui/tickets/components/panels/CompulsoryInsurancePenaltyPanel';
import { HighwayMaintenanceFeePenaltyPanel } from '#/components/ui/tickets/components/panels/HighwayMaintenanceFeePenaltyPanel';
import {
  useTabBar,
  Tabbar,
  TABS_CONFIG,
} from '#/components/ui/tickets/components/TicketsTabbar';
import {
  useTicketCounts,
  TicketCountsStates,
} from '#/components/ui/tickets/components/useTicketCounts';
import { EtcTicketState } from '../etc/model';
import { HighwayMaintenanceFeeTicketState } from '../highway-maintenance-fee/model';
import { CompulsoryInsurancePenaltyTicketState } from '../compulsory-insurance-penalty/model';
import { HighwayMaintenanceFeePenaltyTicketState } from '../highway-maintenance-fee-penalty/model';
import { Paper } from '@mantine/core';
import { TICKET_MODE } from '../config';

const availableStates: TicketCountsStates = {
  etc: [
    EtcTicketState.PENDING,
    EtcTicketState.CHARGING,
    EtcTicketState.CHARGE_SUCCESS,
  ],
  hmf: [
    HighwayMaintenanceFeeTicketState.PENDING,
    HighwayMaintenanceFeeTicketState.CHARGING,
    HighwayMaintenanceFeeTicketState.CHARGE_SUCCESS,
  ],
  cip: [
    CompulsoryInsurancePenaltyTicketState.PENDING,
    CompulsoryInsurancePenaltyTicketState.CHARGING,
    CompulsoryInsurancePenaltyTicketState.CHARGE_SUCCESS,
  ],
  hmfp: [
    HighwayMaintenanceFeePenaltyTicketState.PENDING,
    HighwayMaintenanceFeePenaltyTicketState.CHARGING,
    HighwayMaintenanceFeePenaltyTicketState.CHARGE_SUCCESS,
  ],
};

function PendingTickets() {
  const { currentTab, navigateTab } = useTabBar();
  const counts = useTicketCounts(availableStates);
  const mode = TICKET_MODE.PENDING;

  return (
    <Paper shadow="xl" radius="lg" p="md">
      <Layout title="查繳任務">
        <Tabbar
          current={currentTab}
          tabsConfig={TABS_CONFIG.map((p) => ({
            ...p,
            count: counts[p.key] ?? 0,
          }))}
          onChange={(k) => {
            if (!k) return;
            navigateTab(k);
          }}
          shouldRedirectToDefault
        >
          <EtcPanel availStates={availableStates.etc} mode={mode} />
          <HighwayMaintenanceFeePanel
            availStates={availableStates.hmf}
            mode={mode}
          />
          <CompulsoryInsurancePenaltyPanel
            availStates={availableStates.cip}
            mode={mode}
          />
          <HighwayMaintenanceFeePenaltyPanel
            availStates={availableStates.hmfp}
            mode={mode}
          />
        </Tabbar>
      </Layout>
    </Paper>
  );
}

export default PendingTickets;
